import { supabase } from './config';

/**
 * Create user profile
 */
export const createUserProfile = async (userId, profileData) => {
  try {
    console.log('📝 Creating profile for user:', userId);
    console.log('Profile data:', profileData);
    
const { data, error } = await supabase
      .from('users')
      .insert({
        id: userId,
        email: profileData.email,
        name: profileData.name,
        description: profileData.description || '',
        profile_picture: profileData.profilePicture,
        background: profileData.background || '#667eea',
        date_of_birth: profileData.dateOfBirth,
        gender: profileData.gender,
      })
      .select()
      .single();

    if (error) {
      console.error('❌ Supabase insert error:', error);
      throw error;
    }

    console.log('✅ Profile created:', data);
    return { success: true, profile: data };
  } catch (error) {
    console.error('❌ Create profile error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get user profile
 */
export const getUserProfile = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('users')
      .select('*')
      .eq('id', userId)
      .single();

    if (error) throw error;

return {
      success: true,
      profile: {
        name: data.name,
        profile_picture: data.profile_picture,
        background: data.background,
        description: data.description,
        date_of_birth: data.date_of_birth,
        online_status: data.online_status,
        last_seen: data.last_seen,
        gender: data.gender,
        banned: data.banned || false,
        ban_reason: data.ban_reason,
      },
    };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

/**
 * Update user profile
 */
export const updateUserProfile = async (userId, updates) => {
  try {
    console.log('📝 Updating profile for user:', userId);
    console.log('Updates:', updates);
    
    const { data, error } = await supabase
      .from('users')
      .update(updates)
      .eq('id', userId)
      .select()
      .single();

    if (error) {
      console.error('❌ Supabase update error:', error);
      throw error;
    }

    console.log('✅ Profile updated:', data);
    return { success: true, profile: data };
  } catch (error) {
    console.error('❌ Update profile error:', error);
    return { success: false, error: error.message };
  }
};